<template>
  <div class="title-wrap">
    <div class="table-wrap">
      <div class="filter">
        <el-input
          style="width: 200px"
          placeholder="请输入广告模板名称"
          suffix-icon="el-icon-search"
          @change="searchData"
          v-model="searchStr"
        >
        </el-input>
        <el-select style="width: 200px; margin-left: 12px" v-model="creator" @change="searchData" placeholder="请选择创建者">
          <el-option label="全部创建者" :value="null"> </el-option>
          <el-option v-for="item of createrList" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </div>
      <div class="table">
        <el-table :max-height="tableHeight" ref="table" :data="tableData" style="width: 100%">
          <el-table-column prop="platform" label="广告平台">
            <template>Google</template>
          </el-table-column>
          <el-table-column prop="templateName" label="模板名称"></el-table-column>
          <el-table-column prop="templateDesc" width="500" label="模板描述"></el-table-column>
          <el-table-column prop="creator" width="150" label="创建者"> </el-table-column>
          <el-table-column prop="createTime" width="160" label="创建时间"></el-table-column>
          <el-table-column prop="modifyTime" width="160" label="模板更新时间"></el-table-column>
          <el-table-column prop="operate" label="操作" align="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="deletePkg(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <self-pagination
          class="footer-page"
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdCreatorList_gdt, getAdTemplateList_gdt, deleteAdTemplate_gdt } from "@/api/platReport.js";
export default {
  data() {
    return {
      searchStr: "",
      creator: null,
      tableHeight: window.innerHeight - 210,
      pageData: {
        total: 10,
        size: 10,
        page: 1,
      },
      tableData: [],
      createrList: [],
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.initSelect();
    this.getData();
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },

  methods: {
    initSelect() {
      getAdCreatorList_gdt({
        platform: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.createrList = res.data;
        }
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.getData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getData();
    },
    searchData() {
      this.pageData.page = 1;
      this.getData();
    },
    getData() {
      //查询广告模板
      getAdTemplateList_gdt({
        templateName: this.searchStr,
        creator: this.creator,
        page: this.pageData.page,
        size: this.pageData.size,
        platform: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.pageData.total = res.data.total;
          this.tableData = res.data.list;
        }
      });
    },
    refresh() {
      this.tableHeight = window.innerHeight - 210;
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    deletePkg(data) {
      this.$confirm("确定删除该广告模板?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAdTemplate_gdt({ id: data.id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "广告模板删除成功",
                type: "success",
              });
              this.pageData.page = 1;
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.title-wrap {
  padding: 16px;
  .table-wrap {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .filter {
      display: flex;
    }
    .table {
      margin-top: 20px;
      width: 100%;
    }
  }
  .modal-table {
    margin-top: 12px;
    /deep/ .el-table__cell {
      padding: 4px;
    }
    /deep/ th {
      height: 35px;
    }
  }
}
</style>
